<template>
  <div>
    <div :id="chartName"
         style="width: 100%; background-color: #FFFFFF;"
         :style="'height: ' + height"></div>
  </div>
</template>
<script>
  import moment from 'moment'

  require('amcharts3')
  require('amcharts3/amcharts/serial')
  require('amcharts3/amcharts/themes/light')
  require('amcharts3/amcharts/lang/fr')

  export default {
    name: 'StatsCharts',
    props: {
      entities: {
        type: Array,
        required: true
      },
      entityKey: {
        type: String,
        required: true
      },
      dateParam: {
        type: String,
        default: 'date'
      },
      chartType: {
        type: String,
        default: 'line'
      },
      chartName: {
        type: String,
        default: 'chart'
      },
      height: {
        type: String,
        default: '500px'
      },
      customName: {
        type: Function,
        default (val) {
          return val.name
        }
      }
    },
    data () {
      return {
        line: {
          type: 'line',
          fillColors: '#FFFFFF',
          bullet: 'round'
        },
        column: {
          type: 'column',
          fillAlphas: 0.9,
          lineAlpha: 0.2
        }
      }
    },
    methods: {
      dirtyInit () {
        let data = this.processData(this.entities)
        this.makeChart(this.chartName, data)
      },
      processData (entities) {
        let data = {
          dataProvider: [],
          graphs: []
        }

        let keys = entities.map(x => {
          return this.customName(x)
        })

        let addEntry = function (date, entity = null) {
          let entry = {date}
          keys.forEach(k => {
            entry[k] = 0
          })
          return entry
        }

        let scale = 'YYYY-MM'
        let tmpData = {}
        let graphKeys = {}

        entities.forEach(entity => {
          if (entity.data) {
            let entityData = entity.data[this.entityKey] || []

            let name = this.customName(entity)
            let entityPk = entity.pk

            if ((entityPk in graphKeys) === false) {
              graphKeys[entityPk] = {
                pk: entityPk,
                name,
                _color: entity._color
              }
            }
            entityData.forEach(x => {
              let date = moment(x[this.dateParam])
              date = date.format(scale)

              if (!(date in tmpData)) {
                tmpData[date] = addEntry(date)
              }
              tmpData[date][name] += 1
            })
          }
        })

        tmpData = Object.values(tmpData)
        tmpData.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date)
        })

        Object.values(graphKeys).forEach(e => {
          let graph = Object.assign({
            balloonText: '[[title]] : [[value]]',
            bullet: 'round',
            bulletBorderAlpha: 1,
            bulletBorderColor: '#FFD668',
            bulletColor: '#FFFFFF',
            fillColors: '#FFD668',
            id: e.name,
            lineColor: '#FFD668',
            lineThickness: 2,
            title: e.name,
            valueField: e.name
          }, this[this.chartType])
          data.graphs.push(graph)
        })

        data.dataProvider = tmpData
        return data
      },
      makeChart (container, data) {
        window.AmCharts.makeChart(container,
          {
            path: 'static/amcharts',
            language: 'fr',
            color: '#919191',
            fontSize: 10,
            type: 'serial',
            categoryField: 'date',
            dataDateFormat: 'YYYY-MM',
            theme: 'default',
            categoryAxis: {
              dashLength: 2,
              gridAlpha: 0.10,
              gridColor: '#000000',
              gridPosition: 'start',
              startOnAxis: true,
              parseDates: true,
              axisColor: '#CCCCCC'
            },
            balloon: {
              borderAlpha: 0.12,
              borderThickness: 1,
              shadowAlpha: 0
            },
            chartScrollbar: {
              enabled: true,
              graphType: this.chartType,
              selectedBackgroundColor: '#f7f7f7'
            },
            chartCursor: {
              enabled: true,
              animationDuration: 0.30,
              cursorAlpha: 0.50,
              cursorColor: '#000'
            },
            trendLines: [],
            graphs: data.graphs.slice(),
            guides: [],
            valueAxes: [
              {
                id: 'ValueAxis-1',
                axisColor: '#CCC',
                gridColor: '#E8E8E8',
                gridAlpha: 1,
                title: ''
              }
            ],
            allLabels: [],
            legend: {
              valueAlign: 'left',
              enabled: true,
              useGraphSettings: true
            },
            titles: [
              {
                id: 'Title-1',
                size: 12,
                color: '#0e152c',
                text: this.chartName
              }
            ],
            dataProvider: data.dataProvider.slice()
          }
        )
      }
    },
    mounted () {
      this.dirtyInit()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/StatsCharts.vue